import React from "react";
import { Card } from "./ui/card";
import { Clock, Sparkles, CheckCircle, Wrench } from "lucide-react";

const Trust = ({ language }) => {
  const content = {
    es: {
      title: "Por qué elegir ProntoFix",
      subtitle: "Servicio profesional y confiable en Valencia",
      points: [
        {
          icon: Clock,
          title: "Presupuesto rápido",
          description: "Respuesta en WhatsApp en menos de 2 horas",
        },
        {
          icon: CheckCircle,
          title: "Puntualidad",
          description: "Llego a la hora acordada, siempre",
        },
        {
          icon: Sparkles,
          title: "Trabajo limpio",
          description: "Dejo todo ordenado y limpio después del trabajo",
        },
        {
          icon: Wrench,
          title: "Herramientas básicas",
          description: "Traigo todas las herramientas necesarias",
        },
      ],
    },
    en: {
      title: "Why choose ProntoFix",
      subtitle: "Professional and reliable service in Valencia",
      points: [
        {
          icon: Clock,
          title: "Quick quote",
          description: "WhatsApp response in less than 2 hours",
        },
        {
          icon: CheckCircle,
          title: "Punctuality",
          description: "I arrive at the agreed time, always",
        },
        {
          icon: Sparkles,
          title: "Clean work",
          description: "I leave everything tidy and clean after the job",
        },
        {
          icon: Wrench,
          title: "Basic tools",
          description: "I bring all the necessary tools",
        },
      ],
    },
  };

  const currentContent = content[language];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            {currentContent.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {currentContent.subtitle}
          </p>
        </div>

        {/* Trust Points Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {currentContent.points.map((point, index) => {
            const IconComponent = point.icon;
            return (
              <Card
                key={index}
                className="p-6 border border-gray-200 rounded-xl hover:border-[#2563EB] shadow-sm hover:shadow-md"
              >
                <div className="flex flex-col items-center text-center">
                  {/* Icon */}
                  <div className="w-14 h-14 bg-blue-50 rounded-full flex items-center justify-center mb-4">
                    <IconComponent className="w-7 h-7 text-[#2563EB]" />
                  </div>

                  {/* Title */}
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {point.title}
                  </h3>

                  {/* Description */}
                  <p className="text-sm text-gray-600">{point.description}</p>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Trust;
